import * as types from '../types';

export default {
  [types.SERVICE_TEST](state, data) {
    state.serviceTestCode = data.data;
  },
};
